import React from 'react'

import styles from './styles.module.css'

interface Props {
  leftContent?: React.ReactNode
  rightContent?: React.ReactNode
  showHeader?: boolean
}

const Skeleton: React.FC<Props> = ({ rightContent, leftContent, showHeader = true }) => (
  <div className={styles.skeleton}>
    {!!leftContent && leftContent}
    <div className={styles.rightContainer}>
      {showHeader && <div className={styles.contextHeader}></div>}
      {rightContent}
    </div>
  </div>
)

export default Skeleton
